import React, { useState } from "react";
import { crudData } from "../../services/apiService";
import { toast } from "react-toastify";
import { formatPrice } from "../../MesPages/Panier/Cart";
import axios from "axios"
import { rootUrl } from "../../services/apiService" // ← importer rootUrl
// import * as XLSX from "xlsx";

const CSVUploader = ({ data, onHandlesetData, params, onHandleSuccess }) => {
    const mode = JSON.parse(localStorage.getItem("appMode"));
    const [currentPage, setCurrentPage] = useState(1);
    const [currentFileName, setCurrentFileName] = useState("");
    const rowsPerPage = 10; // Nombre de lignes par page
    const [isLoadingSpinner, setIsLoadingSpinner] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorReport, setErrorReport] = useState([]);

    const handleFileUpload = (event) => {
        const file = event.target.files[0]
        if (!file) return

        const ext = file.name.split('.').pop().toLowerCase()
        if (!['csv', 'xlsx', 'xls'].includes(ext)) {
            toast.error("Format non supporté. Utilisez CSV ou Excel.")
            return
        }

        setCurrentFileName(file.name)
        sendFileToBackend(file)
    }

    const sendFileToBackend = (file) => {
        setIsLoading(true)

        const userData     = JSON.parse(localStorage.getItem("userData"))
        const apiEndpointe = JSON.parse(localStorage.getItem("apiEndpointe"))
        const token        = localStorage.getItem("jwt_token")

        const formData = new FormData()
        formData.append("mode", "parseImportFile")
        formData.append("file", file)
        formData.append("STR_UTITOKEN", userData?.STR_UTITOKEN || "")

        // ← rootUrl + endpoint = URL complète
        const url = `${rootUrl}${apiEndpointe.ConfigurationManagerEndPoint}`
        console.log("URL appelée:", url) // ← vérifier

        axios.post(url, formData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                // ← Pas de Content-Type → axios le gère automatiquement pour FormData
            }
        })
        .then(res => {
            console.log("Réponse backend:", res.data)

            if (res.data.code_statut === "1") {
                const filtered = (res.data.products || []).filter(p => parseInt(p.int_cprquantity) > 0)
                onHandlesetData(filtered)

                // const errors = (res.data.products_not_found || []).map(code => ({
                //     codeProduit: code,
                //     motif: "Produit correspondant introuvable",
                // }))
                // setErrorReport(errors)
                setErrorReport(res.data.products_not_found || [])

                if (filtered.length > 0) {
                    toast.success(`${filtered.length} produit(s) trouvé(s)`)
                } else {
                    toast.warning("Aucun produit trouvé dans ce fichier")
                }
            } else {
                toast.error(res.data.desc_statut)
            }
        })
        .catch(err => {
            console.error("Erreur upload:", err)
            toast.error("Erreur lors de la lecture du fichier")
        })
        .finally(() => setIsLoading(false))
    }
    //product.int_cprquantity = parseInt(product.int_cprquantity, 10);
    // product.int_cprquantity = parseInt(product.int_cprquantity);

    //Pagination logic
    // const indexOfLastRow = currentPage * rowsPerPage;
    // const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    // const currentRows = data && data?.slice(indexOfFirstRow, indexOfLastRow);

    // const totalPages = Math.ceil(data?.length / rowsPerPage);


    // Pagination logic
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;

    // Filtrer les produits avec quantité > 0
    const filteredData = data && data.filter(item => {
        console.log("Item:", item);
        // Vérifier si int_cprquantity existe et est un nombre
        return item && typeof item.int_cprquantity === 'number' && item.int_cprquantity > 0;
    });

    const currentRows = filteredData && filteredData.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil((filteredData?.length || 0) / rowsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleAddToCart = () => {
        setIsLoadingSpinner(true);

        // mapper pour correspondre au format attendu par le backend
        const cmdData = filteredData.map(p => ({
            str_proname:      p.str_proname,
            int_cprquantity:  p.int_cprquantity,
        }))

        const payload = {
            mode:             params.mode.createCommproduittMode,
            LG_AGEID:         params.userData.LG_AGEID,
            STR_COMMNAME:     "",
            STR_COMMADRESSE:  "Plateau, Pullman",
            STR_LIVADRESSE:   "Zone 4, marcory",
            STR_UTITOKEN:     params.userData.STR_UTITOKEN,
            CMD_DATA:         JSON.stringify(cmdData), 
        };

        crudData(payload, params.apiEndpointe.CommandeManagerEndPoint)
            .then((response) => {
                if (response && response.status === 200) {
                    if (response.data.code_statut === "1") {
                        localStorage.setItem("LG_COMMID", response.data.LG_COMMID);
                        onHandleSuccess();

                        if (response.data?.product_unavailable) {
                            let newErrors = response.data?.product_unavailable
                                // .filter(item => !errorReport.some(error => error.codeProduit === item))
                                // .map(item => ({
                                //     codeProduit: item,
                                //     nomProduit:  item.str_prodescription,
                                //     motif:       "Produit en rupture de stock",
                                // }))
                                .filter(item => !errorReport.some(error => error.codeProduit === item.str_proname))
                                .map(item => ({
                                    codeProduit: item.str_proname || item,
                                    nomProduit:  item.str_prodescription || "—",
                                    motif:       "Produit en rupture de stock",
                                }))
                            setErrorReport(errors => [...errors, ...newErrors])
                        }

                        if (response.data.product_added_to_cart > 0) {
                            toast.success(`${response.data.product_added_to_cart} produit(s) ajouté(s) au panier`)
                        }
                    } else {
                        toast.error("Erreur : " + response.data.desc_statut)
                    }
                } else {
                    toast.error("Erreur survenue")
                }
            })
            .catch((error) => {
                console.error(error)
                toast.error("Erreur lors de l'ajout au panier")
            })
            .finally(() => {
                setIsLoadingSpinner(false)
                onHandlesetData([])
                setCurrentFileName("")
                window.scrollTo({ top: 0, behavior: "smooth" })
            })
    }

    return (
        <div style={{}}>
            <h2>Charger un fichier de commande </h2>
            <p style={{ marginTop: "-20px" }}>
                Vous pouvez importer un fichier <u>Csv</u> ou <u>Excel</u> pour
                la saisie de votre commande automatiquement.
                <br />
                Cliquer sur une icone pour telecharger un exemplaire.
            </p>
            <div
                className="d-flex flex-wrap"
                style={{
                    gap: "20px",
                    marginBottom: "20px",
                    marginTop: "-20px",
                }}
            >
                <div>
                    <h5 style={{ margin: 0 }}>Csv:</h5>
                    <a
                        className=""
                        href="/assets/example_file/example.csv"
                        download
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            fill="#008000"
                            width={24}
                            height={24}
                        >
                            <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM200 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm133.1 0l34.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-34.9 0c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1L304 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l42.9 0c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16l0 31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6l0-31.6c0-8.8 7.2-16 16-16z" />
                        </svg>
                    </a>
                </div>
                <div>
                    <h5 style={{ margin: 0 }}>Excel:</h5>

                    <a
                        className=""
                        href="/assets/example_file/example.xlsx"
                        download
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 384 512"
                            fill="#008000"
                            width={24}
                            height={24}
                        >
                            <path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z" />
                        </svg>
                    </a>
                </div>
            </div>
            <div className="d-flex flex-wrap" style={{ gap: "10px" }}>
                <div>
                    <label
                        htmlFor="file-upload"
                        style={{
                            display: "inline-block",
                            backgroundColor: "#2b4fa9",
                            color: "#fff",
                            padding: "10px 20px",
                            fontSize: "16px",
                            borderRadius: "4px",
                            cursor: "pointer",
                        }}
                    >
                        Sélectionner fichier
                    </label>
                </div>
                <input
                    id="file-upload"
                    type="file"
                    accept=".csv, .xlsx"
                    onChange={handleFileUpload}
                    style={{ display: "none" }}
                />
                {currentFileName && (
                    <div>
                        <span>
                            <strong>Fichier sélectionné :</strong>
                        </span>
                        <p>{currentFileName}</p>
                    </div>
                )}
            </div>
            {data && data.length > 0 && (
                <>
                    <div style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            // backgroundColor: "#2b4fa9",
                            color: "#fff",
                            padding: "10px 20px",
                            fontSize: "16px",
                            borderRadius: "4px",
                            cursor: "pointer",
                        }}
                    >
                        <h3>Liste produits à ajouter au panier</h3>
                        {/* Validation button */}
                        {/* <div style={{ textAlign: "center", marginTop: "20px" }}> */}
                            <button
                                onClick={handleAddToCart}
                                disabled={isLoadingSpinner}
                                style={{
                                    width: "17%",
                                    padding: "14px 24px",
                                    backgroundColor: "#214293",
                                    color: "#ffffff",
                                    border: "none",
                                    borderRadius: "12px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                    cursor: isLoadingSpinner ? "not-allowed" : "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "10px",
                                    opacity: isLoadingSpinner ? 0.7 : 1,
                                    transition: "all 0.2s ease",
                                    // boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                                }}
                            >
                                <span>Ajouter au panier</span>
                                
                                {isLoadingSpinner && (
                                    <div className="loader" style={{
                                        width: "18px",
                                        height: "18px",
                                        border: "2px solid #ffffff",
                                        borderBottomColor: "transparent",
                                        borderRadius: "50%",
                                        display: "inline-block",
                                        animation: "rotation 1s linear infinite"
                                    }} />
                                )}
                            </button>
                        {/* </div> */}
                    </div> 
                    
                    <div style={tableContainerStyle}>
                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <th style={tableHeaderStyle}>Code Produit</th>
                                    <th style={tableHeaderStyle}>Libellé</th>
                                    <th style={{ ...tableHeaderStyle, textAlign: "center" }}>Prix de vente</th>
                                    <th style={{ ...tableHeaderStyle, textAlign: "center" }}>Quantité</th>
                                    <th style={{ ...tableHeaderStyle, textAlign: "center" }}>Montant total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentRows &&
                                    currentRows.map((row, index) => {
                                        const isLastRow = index === currentRows.length - 1;
                                        const cellStyle = isLastRow
                                            ? { ...tableCellStyle, borderBottom: "none" }
                                            : tableCellStyle;

                                        return (
                                            <tr key={index}>
                                                <td style={cellStyle}>
                                                    {row.str_proname}
                                                </td>
                                                <td style={cellStyle}>
                                                    {row.str_prodescription}
                                                </td>
                                                <td style={{ ...cellStyle, textAlign: "center" }}>
                                                    {formatPrice(row.int_propricevente)}
                                                </td>
                                                <td style={{ ...cellStyle, textAlign: "center" }}>
                                                    {row.int_cprquantity}
                                                </td>
                                                <td style={{ ...cellStyle, textAlign: "center" }}>
                                                    {formatPrice(row.dbl_montant)}
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination controls */}
                    <div style={{ marginTop: "20px" }}>
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#e6eeff",
                            padding: "10px",
                            borderRadius: "4px",
                            fontFamily: "inherit",
                        }}>
                            {/* Bouton précédent */}
                            <button
                                onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    backgroundColor: "transparent",
                                    color: "#2b4fa9",
                                    border: "none",
                                    padding: "8px 12px",
                                    cursor: currentPage === 1 ? "default" : "pointer",
                                    opacity: currentPage === 1 ? 0.5 : 1,
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                }}
                            >
                                ← PREC
                            </button>

                            {/* Logique d'affichage des pages */}
                            {(() => {
                                // Calculer les pages à afficher
                                const pageNumbers = [];
                                const totalPagesToShow = 4; // Nombre total de pages à afficher (hors ellipsis)

                                // Toujours afficher la page 1
                                if (totalPages >= 1) {
                                    pageNumbers.push(
                                        <button
                                            key={1}
                                            onClick={() => handlePageChange(1)}
                                            style={{
                                                backgroundColor: currentPage === 1 ? "#2b4fa9" : "transparent",
                                                color: currentPage === 1 ? "white" : "#2b4fa9",
                                                border: "none",
                                                borderRadius: "4px",
                                                padding: "8px 12px",
                                                margin: "0 4px",
                                                cursor: "pointer",
                                                fontWeight: "bold",
                                                fontSize: "14px",
                                                minWidth: "36px",
                                                textAlign: "center",
                                            }}
                                        >
                                            1
                                        </button>
                                    );
                                }

                                // Ajouter ellipsis si nécessaire
                                if (currentPage > 3) {
                                    pageNumbers.push(
                                        <span key="ellipsis1" style={{
                                            color: "#2b4fa9",
                                            padding: "8px 4px",
                                            fontWeight: "bold",
                                        }}>
                                            ...
                                        </span>
                                    );
                                }

                                // Ajouter les pages autour de la page courante
                                const startPage = Math.max(2, currentPage - 1);
                                const endPage = Math.min(totalPages - 1, currentPage + 1);

                                for (let i = startPage; i <= endPage; i++) {
                                    if (i !== 1 && i !== totalPages) { // Éviter de dupliquer la première et dernière page
                                        pageNumbers.push(
                                            <button
                                                key={i}
                                                onClick={() => handlePageChange(i)}
                                                style={{
                                                    backgroundColor: currentPage === i ? "#2b4fa9" : "transparent",
                                                    color: currentPage === i ? "white" : "#2b4fa9",
                                                    border: "none",
                                                    borderRadius: "4px",
                                                    padding: "8px 12px",
                                                    margin: "0 4px",
                                                    cursor: "pointer",
                                                    fontWeight: "bold",
                                                    fontSize: "14px",
                                                    minWidth: "36px",
                                                    textAlign: "center",
                                                }}
                                            >
                                                {i}
                                            </button>
                                        );
                                    }
                                }

                                // Ajouter les pointillés si nécessaire
                                if (currentPage < totalPages - 2) {
                                    pageNumbers.push(
                                        <span key="ellipsis2" style={{
                                            color: "#2b4fa9",
                                            padding: "8px 4px",
                                            fontWeight: "bold",
                                        }}>
                                            ...
                                        </span>
                                    );
                                }

                                // afficher la dernière page si elle existe et est différente de la première
                                if (totalPages > 1) {
                                    pageNumbers.push(
                                        <button
                                            key={totalPages}
                                            onClick={() => handlePageChange(totalPages)}
                                            style={{
                                                backgroundColor: currentPage === totalPages ? "#2b4fa9" : "transparent",
                                                color: currentPage === totalPages ? "white" : "#2b4fa9",
                                                border: "none",
                                                borderRadius: "4px",
                                                padding: "8px 12px",
                                                margin: "0 4px",
                                                cursor: "pointer",
                                                fontWeight: "bold",
                                                fontSize: "14px",
                                                minWidth: "36px",
                                                textAlign: "center",
                                            }}
                                        >
                                            {totalPages}
                                        </button>
                                    );
                                }

                                return pageNumbers;
                            })()}

                            {/* Bouton suivant */}
                            <button
                                onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    backgroundColor: "transparent",
                                    color: "#2b4fa9",
                                    border: "none",
                                    padding: "8px 12px",
                                    cursor: currentPage === totalPages ? "default" : "pointer",
                                    opacity: currentPage === totalPages ? 0.5 : 1,
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                }}
                            >
                                SUIV →
                            </button>
                        </div>
                    </div>

                    
                </>
            )}

            {errorReport.length > 0 && (
                <div>
                    <h3 style={errorTitleStyle}>
                        {/* Icône d'avertissement SVG (Optionnelle) */}
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                            <line x1="12" y1="9" x2="12" y2="13"/>
                            <line x1="12" y1="17" x2="12.01" y2="17"/>
                        </svg>
                        Rapport d'Erreurs
                    </h3>
                    <div style={errorTableContainerStyle}>
                        <table style={errorTableStyle}>
                            <thead>
                                <tr>
                                    <th style={tableHeaderStyleError}>Code Produit</th>
                                    <th style={tableHeaderStyleError}>Nom Produit</th>
                                    <th style={tableHeaderStyleError}>Motif</th>
                                </tr>
                            </thead>
                            <tbody>
                                {errorReport.map((error, index) => {
                                    const isLastRow = index === errorReport.length - 1;
                                    
                                    // Enlève la bordure du bas pour la dernière ligne
                                    const cellStyle = isLastRow
                                        ? { ...tableCellStyleError, borderBottom: "none" }
                                        : tableCellStyleError;

                                    const motifStyle = isLastRow
                                        ? { ...errorMotifStyle, borderBottom: "none" }
                                        : errorMotifStyle;

                                    return (
                                        <tr key={index}>
                                            <td style={cellStyle}>
                                                <code>{error.codeProduit}</code>
                                            </td>
                                            <td style={cellStyle}>
                                                {error.nomProduit}
                                            </td>
                                            <td style={motifStyle}>
                                                {error.motif}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}


        </div>
    );
};

// Styles
const tableContainerStyle = {
  borderRadius: "12px",
  overflow: "hidden", 
  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.06)",
  border: "1px solid #E8EFF9",
  backgroundColor: "#ffffff",
};

// Style principal de la balise <table>
const tableStyle = {
  width: "100%",
  borderCollapse: "separate", 
  borderSpacing: "0",
};

// Style des en-têtes (<th>)
const tableHeaderStyle = {
  padding: "14px 18px",
  backgroundColor: "#214293",
  color: "#ffffff",
  textAlign: "left",
  fontSize: "12px",
  fontWeight: "700",
  textTransform: "uppercase",
  letterSpacing: "0.8px",
  borderBottom: "2px solid #1a3478",
};

// Style des cellules de données (<td>)
const tableCellStyle = {
  padding: "14px 18px",
  borderBottom: "1px solid #E8EFF9",
  fontSize: "14px",
  color: "#334155",
  verticalAlign: "middle",
};


const tableRowHoverStyle = {
  backgroundColor: "#F8FAFC",
  transition: "background-color 0.2s ease",
};

const paginationStyle = {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
};

const pageButtonStyle = {
    margin: "0 5px",
    padding: "5px 10px",
    border: "1px solid #007BFF",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
};

// Style de l'en-tête du rapport 
const errorTitleStyle = {
    color: "#DC2626",
    fontSize: "18px",
    fontWeight: "700",
    marginTop: "32px",
    marginBottom: "16px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
};

// Conteneur pour les bords arrondis et bordure rouge douce
const errorTableContainerStyle = {
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 16px rgba(220, 38, 38, 0.08)",
    border: "1px solid #FCA5A5",
    backgroundColor: "#ffffff",
    marginBottom: "40px",
};

// Tableau principal d'erreurs
const errorTableStyle = {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0",
};

// Style de l'en-tête (th)
const tableHeaderStyleError = {
    padding: "14px 18px",
    backgroundColor: "#DC2626", 
    color: "#ffffff",
    textAlign: "left",
    fontSize: "12px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.8px",
    borderBottom: "2px solid #B91C1C",
};

// Style des cellules (td)
const tableCellStyleError = {
    padding: "14px 18px",
    borderBottom: "1px solid #FEE2E2",
    fontSize: "14px",
    color: "#7F1D1D",
    fontWeight: "600",
    backgroundColor: "#FEF2F2", 
    verticalAlign: "middle",
};


const errorMotifStyle = {
    ...tableCellStyleError,
    fontWeight: "600",
    color: "#991B1B",
};

export default CSVUploader;
